/**
 * @generated SignedSource<<2247695f991cc59371719b1f4a0353a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OfferDealArtistReleases_query$data = {
  readonly artist: {
    readonly displayName: string;
    readonly isWatchingCurrentUserCompany: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"AvatarIcon_actor">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"useFeaturedDealTitle">;
  readonly " $fragmentType": "OfferDealArtistReleases_query";
};
export type OfferDealArtistReleases_query$key = {
  readonly " $data"?: OfferDealArtistReleases_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"OfferDealArtistReleases_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OfferDealArtistReleases_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArtistNode",
      "kind": "LinkedField",
      "name": "artist",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isWatchingCurrentUserCompany",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AvatarIcon_actor"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFeaturedDealTitle"
    }
  ],
  "type": "OfferFeaturedDealInterface",
  "abstractKey": "__isOfferFeaturedDealInterface"
};

(node as any).hash = "535392124e08dde1683ec4b9965ae4e1";

export default node;
